/**
 * Formatage des montants, avec une locale FIXE.
 *
 * `Number.prototype.toLocaleString` appelé sans argument suit la locale du
 * runtime : le serveur rend « 5,920.47 » (en-US par défaut sous Node) et un
 * navigateur français rend « 5 920,47 ». Sur un montant identique, les deux
 * chaînes diffèrent — d'où l'erreur d'hydratation React #418 observée en
 * production sur les fiches magasin, et un prix qui change sous les yeux au
 * moment de l'hydratation.
 *
 * Une locale explicite règle les deux : serveur et client produisent la même
 * chaîne, et les prix s'affichent à la française quel que soit le navigateur —
 * cohérent avec `<html lang="fr">` et avec l'app client.
 */

/** Locale d'affichage des montants. Marché algérien, langue française. */
const MONEY_LOCALE = "fr-DZ";

/**
 * Montant sans unité : « 5 347 », « 53,47 ».
 *
 * Jusqu'à deux décimales, aucune quand le montant est rond — les taxes
 * arrivent avec des décimales (un droit de timbre à 1 % sur 5 347 donne 53,47)
 * alors que les prix catalogue sont entiers.
 */
export function formatAmount(value: number | string | null | undefined): string {
  const n = typeof value === "string" ? Number(value) : value;
  if (n == null || !Number.isFinite(n)) return "0";
  return n.toLocaleString(MONEY_LOCALE, { maximumFractionDigits: 2 });
}

/** Montant avec l'unité : « 5 347 DA ». */
export function formatDA(value: number | string | null | undefined): string {
  return `${formatAmount(value)} DA`;
}
